import { AuthGuard } from '../../../shared/services';
import {Route} from '@angular/router';
import { AssociationLandingComponent } from './association-landing.component';
import { AssociationsDetailsResolver } from '../associations-details/associations-details.resolver';

export const AssociationsLandingRoutes: Route[] = [
  {
    path: 'landing/:id',
    component: AssociationLandingComponent,
    canActivate: [AuthGuard],
    resolve: {
      association: AssociationsDetailsResolver
    }
  }
];
